export default {
  title: 'Anmod om faktura',
  form: {
    is_receipt_required: {
      label: 'Anmod om faktura via e-mail',
    },
    company_name: {
      placeholder: 'Firmanavn (valgfrit)',
    },
    first_name: {
      placeholder: 'Fornavn',
    },
    last_name: {
      placeholder: 'Efternavn',
    },
    address: {
      placeholder: 'Gade + nummer',
    },
    zip_code: {
      placeholder: 'Postnummer',
    },
    city: {
      placeholder: 'By',
    },
    tax_id: {
      placeholder: 'CVR-/skatte-id',
    },
    email: {
      placeholder: 'E-mailadresse',
    },
  },
};
